import React, { memo, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { lazyImport } from "../../utils/lazyImport";

import PrivateRouter, { PrivateRouteProps } from "../../Routes/RootNavigator/PrivateRouter";
import Spinner from "../../utils/Spinner";
import { PublicRouteProps } from "../../Routes/RootNavigator/PublicRouter";
import GenericTableList from "pages/GenericTable/GenericTableList";
import GenericTableDetails from "pages/GenericTable/GenericTableDetails";
import GenericTableCreate from "pages/GenericTable/GenericTableCreate";
import ToPayPickpAdd from "pages/ToPayPickup/ToPayPickup";
import AddBooking from "pages/Booking/AddBooking";
import BookingList from "pages/Booking/BookingList";
import UpdatePOD from "pages/POD/UpdatePOD";
import TrackingAWB from "pages/POD/TrackingAWB";
import AddMotherBag from "pages/MotherBag/AddMotherBag";
import MotherBagList from "pages/MotherBag/MotherBagList";
import ExpenseVouchureList from "pages/Vouchure/ExpenseVouchureList";
import RateCalculator from "pages/Rate/RateCalculator";
import MotherBagOutScan from "pages/MotherBag/MotherBagOutScan";
import MotherBagInScan from "pages/MotherBag/MotherBagInScan";
import ManageDRS from "pages/MotherBag/ManageDRS";
import GenerateAwb from "pages/AWB/GenerateAwb";
import DrsList from "pages/MotherBag/DrsList";
import BookingReport from "pages/Report/BookingReport";
import IntlRateCalculator from "pages/Rate/IntlRateCalculator";
import AddIntlBooking from "pages/Booking/AddIntlBooking";
import SendToThirdParty from "pages/MotherBag/SendToThirdParty";
import AttendanceReport from "pages/Report/AttendanceReport";
import Overedge from "pages/POD/Overedge";
import CashReport from "pages/Report/CashReport";
import VouchureGen from "pages/Billing/VouchureGen";
import CashInvoice from "pages/Billing/CashInvoice";
import CnDnList from "pages/Billing/CnDnList";
import CnDnCreate from "pages/Billing/CnDnCreate";
import CnDnDetail from "pages/Billing/CnDnDetail";
import CustomerBookReport from "pages/ReportCustomer/CustomerBookReport";
import CustomerTrackingAwb from "pages/POD/CustomerTrackingAwb";
import AdminDataChange from "pages/AdminDataChange";
import CreditReport from "pages/Report/CreditReport";
import InvoiceReport from "pages/Report/InvoiceReport";
import PublicSlip from "pages/AWB/PublicSlip";
import PrePickup from "pages/ToPayPickup/PrePickup";
import PickupSlip from "pages/ToPayPickup/PickupSlip";
import EmployeeDeliveryReport from "pages/Report/EmployeeDeliveryReport";
import VendorPayList from "pages/Vendor/VendorPayList";
import WalletList from "pages/Wallet/WalletList";
import FlightSearch from "pages/Report/FlightSearch";
import UserSecurity from "pages/Auth/UserSecurity";
import TrackingPickup from "pages/POD/TrackingPickup";
import GeoList from "pages/GeoTrack/GeoList";
import GeoLiveMap from "pages/GeoTrack/GeoLiveMap";
import GeoMapTimeline from "pages/GeoTrack/GeoMapTimeline";
import CompanyExpensesList from "pages/Expense/CompanyExpensesList";
import SalaryList from "pages/Expense/SalaryList";
import ExpenseReport from "pages/Report/ExpenseReport";
import PaymentOutstanding from "pages/Report/PaymentOutstanding";
import PaymentStatement from "pages/Report/PaymentStatement";
import CollectionReport from "pages/Report/CollectionReport";
import Last6MonthsReport from "pages/Report/Last6MonthsReport";
import ProductWiseReport from "pages/Report/ProductWiseReport";
import RagAiQueAns from "pages/AI/RagAiQueAns";
import Leads from "pages/Cs/Leads";
import NewLead from "pages/Cs/NewLead";
import LeadSuggestions from "pages/Cs/LeadSuggestions";
import NewLeadSuggestion from "pages/Cs/NewLeadSuggestion";
import TicketList from "pages/Ticket/TicketList";
import TicketDetail from "pages/Ticket/TicketDetail";
import TrainSchedule from "pages/Report/TrainSchedule";
import StockReport from "pages/Report/StockReport";
import LetterheadEditor from "pages/Letterhead/LetterheadEditor";
import VendorInvoiceList from "pages/VendorInvoice/VendorInvoiceList";
import VendorInvoiceCreate from "pages/VendorInvoice/VendorInvoiceCreate";
import VendorInvoiceDetail from "pages/VendorInvoice/VendorInvoiceDetail";
import Gstr2bRecon from "pages/Billing/Gstr2bRecon";
import RegularPickupList from "pages/RegularPickup/RegularPickupList";
import PurchaseOrderList from "pages/PurchaseOrder/PurchaseOrderList";
import PurchaseOrderCreate from "pages/PurchaseOrder/PurchaseOrderCreate";

//const { NotFound } = lazyImport(() => import("pages/NotFound"), "NotFound");

const { Dashboard } = lazyImport(() => import("pages/Dashboard"), "Dashboard");

const AppContent = () => {
  const location = useLocation();
  const GenericTables = [
    "branch",
    "subbranch",
    "customer",
    "agent",
    "user",
    "vendor",
    "rate",
    "country",
    "region",
    "state",
    "city",
    "product",
    "pincode",
    "tax",
    "rc_code",
    "international_zone",
    "international_rate",
    "nonbranchcontact",
  ];
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Spinner />
        </div>
      }
    >
      <Routes key={location.key}>
        <Route path="/dashboard">
          <Route index element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" />} />

        <Route path="routing-rule">
          <Route
            // index
            path="list"
            element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<Dashboard />} />
        </Route>

        {GenericTables.map((tbl) => {
          return (
            <Route path={`/master/${tbl}`} key={"route-" + tbl}>
              <Route path="list" element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<GenericTableList tableName={tbl} />} />} />
              {/* <Route path="add" element={<CreateAdmin />} /> */}
              <Route path="list/:id" element={<GenericTableDetails tableName={tbl} />} />
              <Route path="add" element={<GenericTableCreate tableName={tbl} />} />
            </Route>
          );
        })}

        <Route path="geo">
          <Route path="list" element={<GeoList />} />
          <Route path="live-map" element={<GeoLiveMap />} />
          <Route path="map-timeline" element={<GeoMapTimeline />} />
        </Route>

        <Route path="/topay-pickup">
          <Route
            // index
            path="list"
            element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<ToPayPickpAdd />} />
          <Route path="req" element={<PrePickup />} />
          <Route path="slip" element={<PickupSlip />} />
        </Route>
        <Route path="/booking">
          <Route
            // index
            path="list"
            element={<BookingList />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<AddBooking />} />
          <Route path="add-intl" element={<AddIntlBooking />} />
        </Route>
        <Route path="/awb">
          <Route path="generate" element={<GenerateAwb />} />
          <Route path="open-slip" element={<PublicSlip />} />
        </Route>
        <Route path="/rate">
          <Route path="calculate" element={<RateCalculator />} />
          <Route path="intl-calculate" element={<IntlRateCalculator />} />
        </Route>
        <Route path="/mother_bag">
          <Route path="add" element={<AddMotherBag />} />
          <Route path="list" element={<MotherBagList />} />
          <Route path="outscan" element={<MotherBagOutScan />} />
          <Route path="inscan" element={<MotherBagInScan />} />
        </Route>
        <Route path="/drs">
          <Route path="manage" element={<ManageDRS />} />
          <Route path="list" element={<DrsList />} />
        </Route>
        <Route path="/third-party">
          <Route path="manage" element={<SendToThirdParty />} />
        </Route>
        <Route path="/pod">
          <Route path="update" element={<UpdatePOD />} />
          <Route path="tracking" element={<TrackingAWB />} />

          <Route path="overedge" element={<Overedge />} />
        </Route>
        <Route path="/pickup">
          <Route path="tracking" element={<TrackingPickup />} />
        </Route>
        <Route path="/vouchure">
          <Route
            // index
            path="expense/list"
            element={<ExpenseVouchureList />}
          />
        </Route>

        <Route path="/report">
          <Route path="booking" element={<BookingReport />} />
          <Route path="cash" element={<CashReport />} />
          <Route path="credit" element={<CreditReport />} />
          <Route path="invoice" element={<InvoiceReport />} />
          <Route path="attendance" element={<AttendanceReport />} />
          <Route path="emp-delivery" element={<EmployeeDeliveryReport />} />
          <Route path="flight" element={<FlightSearch />} />
          <Route path="train" element={<TrainSchedule />} />
          <Route path="expense" element={<ExpenseReport />} />

          <Route path="outstanding" element={<PaymentOutstanding />} />
          <Route path="statement" element={<PaymentStatement />} />
          <Route path="collection" element={<CollectionReport />} />
          <Route path="last-6-months" element={<Last6MonthsReport />} />
          <Route path="product-wise" element={<ProductWiseReport />} />
          <Route path="stock" element={<StockReport />} />
        </Route>

        <Route path="/master/vendorpayment">
          <Route path="list" element={<VendorPayList />} />
          <Route path="add" element={<GenericTableCreate tableName={"vendorpayment"} />} />
          <Route path="list/:id" element={<GenericTableDetails tableName={"vendorpayment"} />} />
        </Route>

        <Route path="/master/companyexpense">
          <Route path="list" element={<CompanyExpensesList />} />
          <Route path="add" element={<GenericTableCreate tableName={"companyexpense"} />} />
          <Route path="list/:id" element={<GenericTableDetails tableName={"companyexpense"} />} />
        </Route>

        <Route path="/master/salary">
          <Route path="list" element={<SalaryList />} />
          <Route path="add" element={<GenericTableCreate tableName={"salary"} />} />
          <Route path="list/:id" element={<GenericTableDetails tableName={"salary"} />} />
        </Route>

        <Route path="/master/wallet">
          <Route path="list" element={<WalletList />} />
        </Route>

        <Route path="/billing">
          <Route path="vouchure-gen" element={<VouchureGen />} />
          <Route path="cash-invoice" element={<CashInvoice />} />
          <Route path="cn-dn" element={<CnDnList />} />
          <Route path="cn-dn/create" element={<CnDnCreate />} />
          <Route path="cn-dn/:id" element={<CnDnDetail />} />
          <Route path="vendor-invoice" element={<VendorInvoiceList />} />
          <Route path="vendor-invoice/new" element={<VendorInvoiceCreate />} />
          <Route path="vendor-invoice/:id" element={<VendorInvoiceDetail />} />
          <Route path="gstr2b" element={<Gstr2bRecon />} />
        </Route>

        <Route path="/customer-report">
          <Route path="booking" element={<CustomerBookReport />} />
        </Route>
        <Route path="/customer-pod">
          <Route path="tracking" element={<CustomerTrackingAwb />} />
        </Route>

        <Route path="/admin">
          <Route path="data-change" element={<AdminDataChange />} />
          <Route path="rag-question" element={<RagAiQueAns />} />
          <Route path="regular-pickup" element={<RegularPickupList />} />
        </Route>

        <Route path="/purchase-order">
          <Route path="list" element={<PurchaseOrderList />} />
          <Route path="create" element={<PurchaseOrderCreate />} />
          <Route path="edit/:id" element={<PurchaseOrderCreate />} />
          <Route path=":id" element={<PurchaseOrderCreate />} />
        </Route>

        <Route path="/security/user">
          <Route path="list" element={<UserSecurity />} />
        </Route>


        <Route path="/af">
          <Route path="leads" element={<Leads />} />
          <Route path="leads/new" element={<NewLead />} />
          <Route path="leads/edit/:id" element={<NewLead />} />
          <Route path="lead-suggestions" element={<LeadSuggestions />} />
          <Route path="lead-suggestions/new" element={<NewLeadSuggestion />} />
          <Route path="lead-suggestions/edit/:id" element={<NewLeadSuggestion />} />
          <Route path="letterhead" element={<LetterheadEditor />} />
        </Route>

        <Route path="/tickets">
          <Route path="open" element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<TicketList />} />} />
          <Route path="assigned" element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<TicketList />} />} />
          <Route path="detail/:id" element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<TicketDetail />} />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default memo(AppContent);

const defaultPublicRouteProps: Omit<PublicRouteProps, "outlet"> = {
  authenticatedPath: "/",
};

const defaultPrivateRouteProps: Omit<PrivateRouteProps, "outlet"> = {
  authenticationPath: "/login",
};
